import {
    GET_SETTINGS_DATE_ORDER,
    SET_UPDATE_DATE_ORDER_PULL
} from '../actions/SettingsDataOrderPullAction'
import getDateFormatUser from "../../components/getDateFormatUser/getDateFormatUser";
const dateInput = new Date();


const nowDate = getDateFormatUser(dateInput,"next",0);

const initialState = {
    typeOrderDate: "ToDay", //Возможные значения Tomorrow - завтра, ToDay - сегодня, Yesterday - вчера, Week - неделя, Month - месяц, Specify - свободный период
    //Если значение от Tomorrow до Month - значения даты присылает сервер
    //Если значение Specify - то данные по периоду ставятся тут
    dateStartSpecify: nowDate,
    dateStopSpecify: nowDate
}

const SettingsDataOrderPull = function (state = initialState, action) {
    switch (action.type) {
        case GET_SETTINGS_DATE_ORDER: {
            return {
                ...state,
                settingsDateOrderPull: [...action.payload],
            }
        }
        case SET_UPDATE_DATE_ORDER_PULL: {
            return {
                ...state,
                ...action.payload
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default SettingsDataOrderPull
